import React, { useState } from "react";
import apiClient from "../Helpers/apiClient";

const AddressAutocomplete = ({ onAddressSelect }) => {
    const [input, setInput] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    const fetchSuggestions = async (value) => {
        if (value.length < 3) {
            setSuggestions([]);
            return;
        }
        try {
            const response = await apiClient.get("/api/googleplaces/autocomplete", {
                params: { input: value },
            });
            setSuggestions(response.data.predictions || []);
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInput(value);
        fetchSuggestions(value);
    };

    const handleSelect = async (suggestion) => {
        try {
            const response = await apiClient.get("/api/googleplaces/details", {
                params: { placeId: suggestion.place_id },
            });
            const place = response.data.result;
            onAddressSelect((prev) => ({ ...prev, city: place.formatted_address }));
            setInput(place.formatted_address);
            setSuggestions([]);
        } catch (error) {
            console.error("Error fetching place details:", error);
        }
    };

    return (
        <div>
            <input
                type="text"
                value={input}
                onChange={handleInputChange}
                placeholder="Enter Australian address"
                style={{ width: "300px", padding: "8px" }}
            />
            {suggestions.length > 0 && (
                <ul style={{ listStyle: "none", padding: 0, margin: 0, border: "1px solid #ccc" }}>
                    {suggestions.map((suggestion) => (
                        <li
                            key={suggestion.place_id}
                            onClick={() => handleSelect(suggestion)}
                            style={{ padding: "8px", cursor: "pointer", background: "#fff" }}
                        >
                            {suggestion.description}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AddressAutocomplete;
